export interface MotivoServicoModel {
  codigo: number;
  valorIntegracao: string;
  descricao: string;
}

export const CHAVE_TRANCOU_MOTORISTA: MotivoServicoModel = {
  codigo: 1,
  valorIntegracao: "CHAVE_PORTA",
  descricao: "Chave quebrou ao tentar abrir a porta do motorista",
};
export const CHAVE_TRANCOU_IGNICAO: MotivoServicoModel = {
  codigo: 2,
  valorIntegracao: "CHAVE_IGNICAO",
  descricao: "Chave presa no miolo da ignição",
};
export const CHAVE_DENTRO_VEICULO_TRANCADO: MotivoServicoModel = {
  codigo: 3,
  valorIntegracao: "CHAVE_VEICULO",
  descricao: "A chave está dentro do veículo fechado",
};
export const CHAVE_DENTRO_PORTA_MALAS: MotivoServicoModel = {
  codigo: 4,
  valorIntegracao: "CHAVE_PORTA_MALAS",
  descricao: "Quebrou a chave na fechadura do porta-malas",
};
export const PERDEU_CHAVE: MotivoServicoModel = {
  codigo: 5,
  valorIntegracao: "CHAVE_PERDIDA",
  descricao: "Perdeu a chave (sem chave reserva)",
};

export const MOTIVOS_SERVICO_CHAVEIRO: MotivoServicoModel[] = [
  CHAVE_TRANCOU_MOTORISTA,
  CHAVE_TRANCOU_IGNICAO,
  CHAVE_DENTRO_VEICULO_TRANCADO,
  CHAVE_DENTRO_PORTA_MALAS,
];
